const initialClients = [
  {
    id: 3,
    name: "Bob's Bicycles",
    created_at: "2022-09-04T15:20:23.419560Z",
    archived: false,
    date_modified: new Date("2022-09-04T15:20:57.435Z"),
    user: null,
  },
  {
    id: 4,
    name: "Tom's Hardware",
    created_at: "2022-09-04T15:20:30.969605Z",
    archived: false,
    date_modified: new Date("2022-09-04T15:20:30.969Z"),
    user: null,
  },
  {
    id: 5,
    name: "Grace Hospital",
    created_at: "2022-09-04T15:20:42.991242Z",
    archived: false,
    date_modified: new Date("2022-09-04T15:20:42.991Z"),
    user: null,
  },
  {
    id: 6,
    name: "Fresh Supermarket",
    created_at: "2022-09-04T15:21:12.961009Z",
    archived: false,
    date_modified: new Date("2022-09-04T15:21:12.961Z"),
    user: null,
  },
];

const initialArchivedClients = [
  {
    id: 4,
    name: "Tom's Hardware",
    created_at: "2022-09-04T15:20:30.969605Z",
    archived: false,
    date_modified: "2022-09-05T15:26:08.633Z",
    user: null,
  },
  {
    id: 8,
    name: "Allied Accounting",
    created_at: "2022-09-05T15:25:38.003037Z",
    archived: false,
    date_modified: "2022-09-05T15:26:10.635Z",
    user: null,
  },
];

const pieDataInitial = [
  {
    id: "source1",
    label: "empty",
    value: 0,
  },
  {
    id: "source2",
    label: "empty",
    value: 0,
  },
  {
    id: "source3",
    label: "empty",
    value: 0,
  },
];

const funnelDataInitial = {
  applications: 0,
  interviews: 0,
  assessments: 0,
  hires: 0,
};
const initialApplicantSource = {
  Referral: 0,
  LinkedIn: 0,
  Indeed: 0,
  Google: 0,
  Monster: 0,
  Facebook: 0,
  ZipRecruiter: 0,
  SimplyHired: 0,
  Snag: 0,
  Craigslist: 0,
  Other: 0,
};

let host = "";

function addZeroes(num) {
  num = num.toString();
  // console.log("NUM:", num);
  const dec = num.split(".")[1];
  const len = dec && dec.length > 2 ? dec.length : 2;
  return Number(num).toLocaleString(undefined, {
    minimumFractionDigits: len,
    maximumFractionDigits: len,
  });
}

function getPieEntry(a) {
  return {
    id: a[0],
    label: a[0],
    value: a[1],
  };
}
const mergeSources = (data) => {
  const result = {}; //(1)

  data.forEach((basket) => {
    //(2)
    for (let [key, value] of Object.entries(basket)) {
      //(3)
      if (result[key]) {
        //(4)
        result[key] += parseInt(value); //(5)
      } else {
        //(6)
        result[key] = parseInt(value);
      }
    }
  });
  return result; //(7)
};

//sum functions
function add(accumulator, a) {
  return accumulator + a;
}

const groupBy = (objectArray, property) => {
  return objectArray.reduce((acc, obj) => {
    const key = obj[property];
    if (!acc[key]) {
      acc[key] = [];
    }
    // Add object to list for given key's value
    acc[key].push(obj);
    return acc;
  }, {});
};

const countDecimals = function (value) {
  if (value % 1 != 0) return value.toString().split(".")[1].length;
  return 0;
};

export {
  groupBy,
  funnelDataInitial,
  pieDataInitial,
  getPieEntry,
  mergeSources,
  add,
  initialApplicantSource,
  countDecimals,
  addZeroes,
  host,
  initialClients,
};
